import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconClear({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9991 10.7134C13.08 10.7134 10.7141 13.0808 10.7141 16.0013C10.7141 18.9217 13.0808 21.2862 15.9991 21.2862C18.9173 21.2862 21.2855 18.9188 21.2855 16.0013C21.2855 13.0837 18.9188 10.7134 15.9991 10.7134Z"
        fill="white"
      />
      <path d="M16.6808 4H15.3162V7.66498H16.6808V4Z" fill="white" />
      <path
        d="M7.03186 7.9983L9.62413 10.5898L10.5891 9.62411L7.99759 7.03186L7.03186 7.9983Z"
        fill="white"
      />
      <path d="M7.66714 15.3184H4V16.683H7.66714V15.3184Z" fill="white" />
      <path
        d="M7.03174 24.0025L7.99747 24.9682L10.589 22.3752L9.62401 21.4102L7.03174 24.0025Z"
        fill="white"
      />
      <path d="M16.6815 24.3336H15.317V28.0007H16.6815V24.3336Z" fill="white" />
      <path
        d="M21.4095 22.3752L24.0025 24.9668L24.9682 24.0025L22.3759 21.4102L21.4095 22.3752Z"
        fill="white"
      />
      <path d="M28 15.3184H24.3328V16.683H28V15.3184Z" fill="white" />
      <path
        d="M24.9682 7.99601L24.0025 7.03174L21.4095 9.62399L22.3759 10.5897L24.9682 7.99601Z"
        fill="white"
      />
    </svg>
  );
}
